// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__saZ7c","left":"style_left__Pap79","right":"style_right__40uC9"};